import { HTTP } from "../../../http-common";
import { createHelpers } from "vuex-map-fields";
import { getField, updateField } from "vuex-map-fields";
import { httpError } from "../../../models/httpError";
import { Relocation } from "../../../models/Relocation";

export const { mapFields: mapRelocationFields } = createHelpers({
  getterType: `relocation/getField`,
  mutationType: `relocation/updateField`
});

const state = {
  application: new Relocation()
};
const getters = {
  getField
};
const mutations = {
  setRelocation(state, application) {
    state.application = application;
  },
  setProgress(state, message) {
    state.message = message;
  },
  updateField
};

const actions = {
  reset({ commit }) {
    commit("setRelocation", new Relocation());
  },
  getRelocation({ dispatch, rootState }) {
    return new Promise((resolve, reject) => {
      let orderID = rootState.orders.rows[0].orderID;
      HTTP.get("order/GetRelocation/" + orderID)
        .then(function(data) {
          if (data.status == 200) resolve(data.data);
          else reject("No Content");
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({
              message:
                "Error in getting relocation application : " + err.message,
              httpStatus: 500
            })
          );
          reject(err);
        });
    });
  },

  // All disabled due to no need for them currently, holding on for later reuse.
  // getRelocationFromGuid({ dispatch }, guid) {
  //   return new Promise((resolve, reject) => {
  //     HTTP.get("order/GetRelocationFromGuid/" + guid)
  //       .then(function(data) {
  //         if (data.status == 200) resolve(data.data);
  //         else reject("No Content");
  //       })
  //       .catch(err => {
  //         dispatch(
  //           "setMessage",
  //           new httpError({
  //             message:
  //               "Error in getting relocation application : " + err.message,
  //             httpStatus: 500
  //           })
  //         );
  //         reject(err);
  //       });
  //   });
  // },
  // approveRelocation({ dispatch }, relocation) {
  //   return new Promise((resolve, reject) => {
  //     var response = HTTP.post("Order/ApproveRelocation/", relocation);
  //     response
  //       .then(() => {
  //         dispatch(
  //           "setMessage",
  //           new httpError({
  //             message: "Application for Relocation saved",
  //             httpStatus: 200
  //           })
  //         );
  //         resolve();
  //       })
  //       .catch(err => {
  //         dispatch(
  //           "setMessage",
  //           new httpError({
  //             message: "Sending failed : " + err.message,
  //             httpStatus: 500
  //           })
  //         );
  //         reject();
  //       });
  //   });
  // },
  // rejectRelocation({ dispatch }, relocation) {
  //   return new Promise((resolve, reject) => {
  //     var response = HTTP.post("Order/RejectRelocation/", relocation);
  //     response
  //       .then(data => {
  //         dispatch(
  //           "setMessage",
  //           new httpError({
  //             message: "Application for Relocation saved",
  //             httpStatus: 200
  //           })
  //         );
  //         resolve(data.data);
  //       })
  //       .catch(err => {
  //         dispatch(
  //           "setMessage",
  //           new httpError({
  //             message: "Sending failed : " + err.message,
  //             httpStatus: 500
  //           })
  //         );
  //         reject(err);
  //       });
  //   });
  // },
  // dispatchRelocationSMS({ dispatch }, relocation) {
  //   return new Promise((resolve, reject) => {
  //     ;
  //     HTTP.post("Order/SendRelocationSMStoCustomer/", relocation)
  //       .then(data => {
  //         dispatch(
  //           "setMessage",
  //           new httpError({
  //             message: "Application for Relocation saved",
  //             httpStatus: 200
  //           })
  //         );
  //         resolve(data.data);
  //       })
  //       .catch(err => {
  //         dispatch(
  //           "setMessage",
  //           new httpError({
  //             message: "Sending failed : " + err.message,
  //             httpStatus: 500
  //           })
  //         );
  //         reject(err);
  //       });
  //   });
  // },
  // dispatchRelocation({ dispatch }, relocation) {
  //   return new Promise((resolve, reject) => {
  //     var response = HTTP.post(
  //       "Order/SendRelocationEmailtoCustomer/",
  //       relocation
  //     );
  //     response
  //       .then(data => {
  //         dispatch(
  //           "setMessage",
  //           new httpError({
  //             message: "Application for Relocation saved",
  //             httpStatus: 200
  //           })
  //         );
  //         resolve(data.data);
  //       })
  //       .catch(err => {
  //         dispatch(
  //           "setMessage",
  //           new httpError({
  //             message: "Sending failed : " + err.message,
  //             httpStatus: 500
  //           })
  //         );
  //         reject(err);
  //       });
  //   });
  // },
  // generateRelocationPDF({ dispatch }, relocationGUID) {
  //   return new Promise((resolve, reject) => {
  //     ;
  //     var response = HTTP.post("Order/GenerateRelocationPDF/" + relocationGUID);
  //     response
  //       .then(data => {
  //         dispatch(
  //           "setMessage",
  //           new httpError({
  //             message: "Application for Relocation saved",
  //             httpStatus: 200
  //           })
  //         );
  //         resolve(data.data);
  //       })
  //       .catch(err => {
  //         dispatch(
  //           "setMessage",
  //           new httpError({
  //             message: "Application for Relocation failed : " + err.message,
  //             httpStatus: 500
  //           })
  //         );
  //         reject(err);
  //       });
  //   });
  // },
  updateRelocation({ dispatch, commit }, relocation) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post("Order/UpdateRelocation/", relocation);
      response
        .then(data => {
          commit("setRelocation", data.data);
          dispatch(
            "setMessage",
            new httpError({
              message: "Application for Relocation saved",
              httpStatus: 200
            })
          );
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Application for Relocation failed : " + err.message,
              httpStatus: 500
            })
          );
          reject(err);
        });
    });
  },
  populate({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      if (typeof payload.application == "undefined") {
        reject("no data available");
        return;
      }
      let request = {
        template: {
          name: "Relocation",
          recipe: payload.isPDF ? "chrome-pdf" : "phantom-image",
          engine: "handlebars",
          waitForJS: true
        },
        data: payload.application.relocationDetails
      };
      HTTP.post("Report/Generate", request, { responseType: "arraybuffer" })
        .then(res => {
          let blob = new Blob([res.data], {
            type: payload.isPDF ? "application/pdf" : "image/png"
          });

          resolve(blob);
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Error" + err.message,
              httpStatus: 500
            })
          );
          reject(err);
        });
    });
  },
  setMessage({ commit }, message) {
    commit("setProgress", message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit("setProgress", new httpError());
      }, 2000);
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
